<template>
  <div class="pt20">
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <!--<div class="tool_company">-->
        <div class="company-desc design_box">
          {{property.body}}
        </div>
      <!--</div>-->
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    },
    created() {
    }
  };
</script>



